/**
 * WarningIcon/index.js
 * desc: warning icon used for notification ui
 * note: status icon via IconButton; defaults its tooltip + accessible name to the
 *       status label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const WarningIcon = ({ tooltip, ...props }) => (
    <IconButton baseClassName="warning icon" label={ tooltip || translate('icons.warning.tooltip.text') } tooltip={ tooltip } { ...props }>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fillRule="evenodd" d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zM10.8 6.6h2.4v7.2h-2.4V6.6zM12 17.4a1.2 1.2 0 100-2.4 1.2 1.2 0 000 2.4z"/></svg>
    </IconButton>
);


export default WarningIcon;
